// import axios from "axios";

// interface DownloadExcelGetOptions {
//   apiEndpoint: string;  // full API URL
//   appToken: string;     // authorization token
//   fileName?: string;    // optional filename
// }

// interface DownloadResult {
//   success: boolean;
//   message: string;
// }

// /**
//  * Reusable GET request Excel download
//  */
// export const downloadExcelGet = async ({
//   apiEndpoint,
//   appToken,
//   fileName = "report.xlsx",
// }: DownloadExcelGetOptions): Promise<DownloadResult> => {
//   try {
//     const response = await axios.get(apiEndpoint, {
//       responseType: "blob", // for binary data
//       headers: {
//         accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         apptoken: appToken,
//       },
//     });

//     // Create blob & trigger download
//     const url = window.URL.createObjectURL(new Blob([response.data]));
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", fileName);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//     window.URL.revokeObjectURL(url);

//     return { success: true, message: "✅ Excel downloaded successfully" };
//   } catch (error: any) {
//     console.error("❌ Failed to download Excel:", error);
//     return { success: false, message: "❌ Failed to download Excel" };
//   }
  // };
  import axios from "axios";

  interface DownloadExcelGetOptions {
    apiEndpoint: string;
    appToken: string;
    fileName?: string;
  }

  interface DownloadResult {
    success: boolean;
    message: string;
  }

  /**
   * ✅ Reusable Excel download function
   */
  export const downloadExcelGet = async ({
    apiEndpoint,
    appToken,
    fileName = "report.xlsx",
  }: DownloadExcelGetOptions): Promise<DownloadResult> => {
    try {
      const response = await axios.get(apiEndpoint, {
        responseType: "blob",
        headers: {
          accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          apptoken: appToken,
        },
      });

      // 👉 Prevent page reload issue by handling click safely
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true, message: "Excel downloaded successfully" };
    } catch (error: any) {
      console.error("Failed to download Excel:", error);
      return { success: false, message: "Failed to download Excel" };
    }
  };
